<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	></v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	data: () => ({
		minYear: 1900,
		maxYear: (new Date()).getFullYear(),
	}),
	props: {
		value: 			{ type: Number, default: null },
		generation:		{ type: Object, default: null },
	},
	watch: {
		generation(item) {
			this.onRefresh(item)
		},
	},
	computed: {
		//...mapGetters('VehicleCategory', [ 'items' ]),
		items() {
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);
			return arrayRange(this.minYear, this.maxYear, 1).reverse();
		},
	},
	methods: {
		//...mapActions('VehicleCategory', [ 'load' ]),

		onLoad() {
			if(this.generation) {
				this.minYear = this.generation?.yearFrom ? this.generation.yearFrom : 1900
				this.maxYear = this.generation?.yearTo ? this.generation.yearTo : (new Date()).getFullYear()
			}
		},
	},
}
</script>